// @flow
import type { Window } from '../types';

export default function getNodeName(element: ?Node | Window) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
